export default "__VITE_PUBLIC_ASSET__38626996__"